import { Component, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { StepStatus } from "@enums/step-status.enum";
import { IStep } from "@interfaces/step.interface";
import { StepsService } from "@services/steps/steps.service";

@Component({
    selector: "app-stepper",
    templateUrl: "./stepper.component.html",
    styleUrls: ["./stepper.component.scss"],
    standalone: false
})
export class StepperComponent implements AfterViewInit {
  public steps: IStep[] = [];
  private step: number = 0;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stepsService: StepsService,
    private readonly cdRef: ChangeDetectorRef 
  ) {}

  ngAfterViewInit() {
    this.steps = this.stepsService.steps;

    this.stepsService.currentStep.subscribe((currentStep) => {
      this.step = currentStep;

      this.steps.forEach((step, index) => {
        if (index + 1 < this.step) step.status = StepStatus.Complete;
        else if (index + 1 == this.step) step.status = StepStatus.Current;
        else step.status = StepStatus.Pending;
      });
      this.cdRef.detectChanges();
    });
  }

  public get Status(): typeof StepStatus {
    return StepStatus;
  }
}

